import styled from "styled-components";

export const Wrapper = styled.p`
  padding-bottom: 1em;

  font-weight: bold;

  color: red;
`;
